import {derived, writable} from 'svelte/store';
import {DISABLE_LANGS} from '@/const/lang';
import {defaultLangByHost, fixInvalidLang, needFirstTimeRedirect, updateFirstTimeRedirect} from '@/helper/localized-site';
import {langUtil} from '@/helper/lang';
import {envUtil} from '@/helper/env';
import {writeLang} from '@/storage/lang';
import {sd} from '@/da/sd';

export const lang$ = writable(getInitLang());

function getInitLang() {
  if (needFirstTimeRedirect) {
    updateFirstTimeRedirect();
    return defaultLangByHost;
  }
  return readLocalLang();
}

lang$.subscribe((lang) => {
  if (!process.browser || !lang) {
    return;
  }

  if (fixInvalidLang(lang) !== lang) {
    return lang$.set(fixInvalidLang(lang));
  }
  sd.setProfile({language: lang});
  const path = langUtil.parsePathname(window.location.pathname);
  writeLang(lang);
  if (lang === path.lang || envUtil.isApp) {
    return;
  }
  redirectWithLang(path.pathname, lang);
});

export const fixLink$ = derived(
  [lang$],
  ([lang], set) => {
    let fixFunc = (o) => o;

    if (lang !== 'en') {
      fixFunc = (o, type = '') => {
        if (type === 'CMS' && ['cn', 'vi'].indexOf(lang) > -1) {
          return fixRoot(o);
        }
        return '/' + lang + fixRoot(o);
      };
    }

    return set(fixFunc);
  },
  (o) => o
);

// https://fat.phemex.jp/ja/ => https://fat.phemex.jp/ja
function fixRoot(o) {
  return o === '/' ? '' : o;
}

function redirectWithLang(pathname, language) {
  const noLangPath = langUtil.parsePathname(window.location.pathname).pathname;
  const prefix = language === 'en' ? '' : '/' + language;
  const targetPath = prefix + (noLangPath === '/' ? '' : noLangPath);
  const url = location.origin + targetPath + location.search + location.hash;
  location.assign(url);
}

function readLocalLang() {
  if (process.browser) {
    const path = langUtil.parsePathname(window.location.pathname);
    return DISABLE_LANGS.includes(path.lang) ? 'en' : path.lang;
  }
  return 'en';
}
